export function log(...args: any[]) {
	console.log("ghūl:",...args);
}
